// src/hooks/usePermiso.js

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkPermiso } from "../redux/actions/aPermisos";

export const usePermiso = (userId, url) => {
  const dispatch = useDispatch();

  const {permisos,loading} = useSelector((state) => state.permisosReducer);

  const permitido = permisos[url] !== undefined ? permisos[url] : undefined;
  useEffect(() => {
    if (userId && url && permitido === undefined) {
      dispatch(checkPermiso(userId, url));
    }
  }, [userId, url, permitido, dispatch]);

  return {
    permitido,
    loading,
  };
};